import React, { useEffect } from 'react'
import { message } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useDispatch } from 'dva'
import qs from 'query-string'
import { clearAllCookies, validHost } from 'utils'

export default function Index() {
  const dispatch = useDispatch()

  // 创建iframe访问地址 200毫秒后清除 iframe
  const logOut = (url = '') => {
    let iframe = document.createElement('iframe')
    iframe.src = url
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    setTimeout(() => document.body.removeChild(iframe), 200)
  }

  useEffect(() => {
    clearAllCookies()
    ;(async function () {
      const { search } = window.location
      let data = qs.parse(search)
      // 检验是否是西西弗地址
      if (!validHost(data.redirectUrl)) {
        message.error('非法跳转地址', 600000)
        return
      }
      /**
       * 查询需要退出的系统地址接口
       * 轮询地址使用 iframe 调用退出相关系统
       */
      let res: any = await dispatch({
        type: 'login/logout',
        payload: { applicationCode: data?.applicationCode },
      })
      /**
       * loginUrl 登录页面地址
       */
      if (res && res.logoutAddresses && res.logoutAddresses.length) {
        let time = 200 * res.logoutAddresses.length
        res.logoutAddresses.forEach(item => logOut(item))
        // 等待iframe调用完成
        setTimeout(() => (window.location.href = data.redirectUrl), time)
      } else {
        window.location.href = data.redirectUrl
      }
    })()
  }, [dispatch])
  return (
    <div style={{ paddingTop: 100, textAlign: 'center' }}>
      <LoadingOutlined />
    </div>
  )
}
